<template>
    <v-snackbar
        :color="color"
        :timeout="timer"
        v-model="showSnackbar"
        top>
        <v-icon class="core-toast__icon" :icon="icon" /> {{ message }}
    </v-snackbar>
</template>

<script>
import { mdiCheck } from '@mdi/js';

export default {
    name: 'CoreToast',
    data() {
        return  {
            showSnackbar: false,
            message: '',
            color: 'success',
            icon: mdiCheck,
            timer: 3000
        }
    },
    methods: {
        show(data) {
            this.message = data.message || 'missing "message".';
            this.color = data.color || 'success';
            this.timer = data.timer || 3000;
            this.icon = data.icon || mdiCheck;
            this.showSnackbar = true;
        }
    }
}
</script>

<style scoped>
.core-toast__icon {
    margin-right: 8px;
}
</style>
